import axios from 'axios'
import * as vars from '@/vars.json'

const httpAxios = axios.create({
  params: {},
})

export const plans = {
  namespaced: true,
  actions: {
    editLocalPlan ({ commit }, dataLocalPlan) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/editLocalPlan', dataLocalPlan).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deleteLocalPlan ({ commit }, dataLocalPlan) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/deleteLocalPlan', dataLocalPlan).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    createPlan ({ state, rootState }, plan) {
      return new Promise((resolve, reject) => {
        delete plan.created
        httpAxios.post(vars.url + '/createPlan', plan).then((response) => {
          if (response.data.status) {
            resolve(response.data.status)
          } else {
            resolve(response.data.status)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deletePlan ({ state, rootState }, plan) {
      return new Promise((resolve, reject) => {
        delete plan.created
        httpAxios.post(vars.url + '/deletePlan', plan).then((response) => {
          if (response.data.status) {
            resolve(response.data)
          } else {
            resolve(response.data)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
  },
}
